@if (variant === 'tile') {
<div id="component" class="container-fluid p-0 bg-white rounded">
    @if(recommendation?.viewed){
    <p class="bg-dark text-white p-1 ps-2 rounded-top fs-6">{{ timestamp_diff | relativeDateCmsText:'si_pts_chrome_tips_tile_viewed':recommendation?.viewed | async }}</p>
    }

    <div class="row justify-content-center align-items-center p-3">
        <div class="position-relative col-8 col-sm-6 col-md-5 col-xl-3 my-3">
            <img [src]="image" [alt]="recommendation?.recommendation?.img_alt ?? ''">
        </div>
        <div class="col-0 align-items-center">
            <h2>{{recommendation?.recommendation?.header}}</h2>
            <p [appParagraph]="2">
                {{recommendation?.recommendation?.text}}
            </p>

            <div class="d-grid gap-2 col-12 mx-auto my-2">
                <app-smart-link [recommendation]="recommendation?.recommendation"></app-smart-link>
            </div>

        </div>
    </div>
</div>
} @else {
<!-- One row in a list of tips (IBrand.tipsLayout 'list'): image, text and a button or round link -->
<div class="tip-row" [class.tip-row-highlight]="variant === 'highlight'">
    <div class="tip-row-content">
        <img class="tip-row-image" [src]="image" [alt]="recommendation?.recommendation?.img_alt ?? ''">
        <div class="tip-row-text">
            <h3>{{recommendation?.recommendation?.header}}</h3>
            <p>{{recommendation?.recommendation?.text}}</p>
            @if(recommendation?.viewed){
            <p class="tip-row-viewed">{{ timestamp_diff | relativeDateCmsText:'si_pts_chrome_tips_tile_viewed':recommendation?.viewed | async }}</p>
            }
        </div>
    </div>
    <app-smart-link [recommendation]="recommendation?.recommendation" [variant]="variant === 'highlight' ? 'button' : 'chevron'"></app-smart-link>
</div>
}
